module.exports = __webpack_public_path__ + "static/img/case_detail_15_1.f593d48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_15_1.png
// module id = FRa+
// module chunks = 34